export const registerVariablesPlugin = (getVariables, isEmailEnabled) => {
  if (typeof window !== "undefined" && window.tinymce) {
    window.tinymce.PluginManager.add("variables", editor => {
      const createMenuItems = () => {
        const variables =
          typeof getVariables === "function" ? getVariables() : getVariables;

        const canInsert =
          typeof isEmailEnabled === "function" ? !isEmailEnabled() : true;

        if (!canInsert) {
          return [
            {
              type: "menuitem",
              text:
                "Variáveis não disponíveis para comunicados com envio de e-mail",
              disabled: true
            }
          ];
        }

        if (!variables || variables.length === 0) {
          return [
            {
              type: "menuitem",
              text: "Nenhuma variável disponível",
              disabled: true
            }
          ];
        }

        return variables.map(variable => ({
          type: "menuitem",
          text: variable.label,
          onAction: () => {
            const placeholder = `\${${variable.value}}`;
            editor.insertContent(
              `<span class="tiny-variable" data-variable="${variable.value}" contenteditable="false">${placeholder}</span>`
            );
          }
        }));
      };

      editor.ui.registry.addMenuButton("variables", {
        tooltip: "Variáveis",
        icon: "code-sample",
        fetch: callback => {
          callback(createMenuItems());
        }
      });

      return {
        getMetadata: () => ({
          name: "Variables Plugin",
          url: "https://waybee.com.br"
        })
      };
    });
  }
};
